import React from "react";
import { Link } from "react-router-dom";
import CategoryBadge from "./CategoryBadge";
import VoteButtons from "./VoteButtons";
import { MapPin, Building2 } from "lucide-react";
import { projectPath } from "../lib/seo";

export default function ProjectCard({ project, onVoteChange, requestLogin }) {
  return (
    <article
      className="card-flat p-5 sm:p-6 flex flex-col gap-4"
      data-testid={`project-card-${project.project_id}`}
    >
      <div className="flex items-start justify-between gap-4">
        <div className="flex items-center gap-2 flex-wrap">
          <CategoryBadge category={project.category} />
          <span className="text-[11px] uppercase tracking-[0.18em] text-foreground/60 font-semibold">
            {project.status}
          </span>
        </div>
        <VoteButtons project={project} onChange={onVoteChange} requestLogin={requestLogin} />
      </div>

      <Link to={project.canonical_path || projectPath(project.category, project.slug || project.title)} className="group">
        <h3 className="font-display text-xl sm:text-2xl font-bold tracking-tight leading-snug group-hover:text-primary transition-colors">
          {project.title}
        </h3>
      </Link>

      <p className="text-sm leading-relaxed text-foreground/75 line-clamp-3">
        {project.description}
      </p>

      <div className="flex items-center gap-4 text-xs text-foreground/60 pt-2 border-t border-border">
        <span className="inline-flex items-center gap-1.5">
          <MapPin size={14} /> {project.city}, {project.county}
        </span>
        <span className="inline-flex items-center gap-1.5">
          <Building2 size={14} /> {project.authority}
        </span>
        <span className="ml-auto tabular-nums">
          {project.upvotes} susțin · {project.downvotes} nu susțin
        </span>
      </div>
    </article>
  );
}
